(function (angular, app) {
   "use strict";
    
   // Slider
   angular.module(app.modules.ui.name)
      .directive(app.modules.ui.directives.scroller, ScrollerDirective);
      
   ScrollerDirective.$inject = ["$timeout", "$compile"];
   
   function ScrollerDirective($timeout, $compile){
      
      var ctrl = this;
      
      return {
         restrict : "A"
         , templateUrl : "app/ui/directives/scroller.html"
         , scope: {
            callback: "&"
         }
         , link : function (scope, element, attrs) {
            
            // DragDealer
            var dd;
            
            // ElementID
            var elementId = "";
            var isLoaded = false;
            
            // Default Options
            var options = {
               minValue: 0
               , maxValue: 0
               , disableValue : null
               , parValue: 0
               , holeNumber: 0
               , currentValue: 0
               , playerIndex: 0
               , allowNull: false
               , precision: 0
               , itemSize: 52
               , itemMargin: 4
               , activeClass : "act"
               , parAry: []
            }

            var dragSteps = {
               step : ""
               , isDrag : false
            }

            var loadOptions = function (objStr) {
               
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {
                     if (obj.minValue) {
                        options.minValue = obj.minValue;
                     }
                     if (obj.maxValue) {
                        options.maxValue = Number(obj.maxValue);
                     } else {
                        options.maxValue = 0;
                     }
                     if (obj.disableValue) {
                        options.disableValue = Number(obj.disableValue);
                     } else {
                        options.disableValue = null;
                     }
                     if (obj.precision) {
                        options.precision = obj.precision;
                     }
                     if (obj.activeClass) {
                        options.activeClass = obj.activeClass;
                     }
                     if (obj.className) {
                        scope.sc.className = obj.className;
                     }
                     if (obj.allowNull) {
                        options.allowNull = obj.allowNull;
                     }
                     if (obj.holeNumber) {
                        options.holeNumber = obj.holeNumber;
                     }
                     if (obj.parValue) {
                        if (!isNaN(obj.parValue)) {
                           options.parValue = Number(obj.parValue);
                        }
                     }
                     if (obj.currentValue) {
                        if (!isNaN(obj.currentValue)) {
                           options.currentValue = Number(obj.currentValue);
                        } else {
                           options.currentValue = null;
                        }
                     } else {
                        options.currentValue = null;
                     }
                     if (obj.playerIndex) {
                        options.playerIndex = obj.playerIndex;
                     }
                     if (obj.parArray) {
                        options.parAry = obj.parArray;
                     }
                  }
               }
               if (!isLoaded) {
                  loadSlider();
               } else {
                  updateSlider();
               }
            }
            
            // ID of Element, Min Val, Max Val, Precision Decimals
            var loadSlider = function(){
               
               var min       = options.minValue;
               var max       = options.maxValue;
               var precision = options.precision;

               
               
               // Add Items to Handle.
               var html = ""
               var cnt  = 0;
               
               
               // Nulls allowed will put a chevron to start
               if (options.allowNull){
                  html = html + "<a href=\"\" class=\"nbr nbr_0 null\" ng-click=\"sc.f.setStep(0)\"><span class='lnr lnr-chevron-right'></span></a>";
               }
               
               var lp = 0;
               for (var x = min; x < max+1; x++){
                  cnt = cnt + 1;
                  var d = x;
                  var pv = null;

                  if (precision == 1){
                     d = (d/10.0).toFixed(1);
                  }

                  if (options.parAry.length > 0) {
                     if (options.parAry[lp]) {
                        pv = Number(options.parAry[lp]);
                     }
                  }
                  
                  html += "<a href=\"\" class=\"nbr nbr_" + cnt + "\" ng-click=\"sc.f.setStep(" + cnt + ")\"><i>" + d + "</i>";
                  if (pv) {
                     html += "<b class='par'>Par " + pv + "</b>"
                  }
                  html += "</a>";
                  
                  lp++;
               } 
               
               if (options.allowNull){
                  cnt = cnt + 1;   
               }
               
               // HTML to dom
               element.find("handle").html(html); 
               
               // Compile new HTML into Scope
               $compile(element.contents())(scope);
               
               // Update Handle Size based on ItemCount
               var handlesize = cnt * (options.itemSize + options.itemMargin);
               element.find("handle").css("width", handlesize + "px")
              
              
               $timeout(function(){
                  dd = new Dragdealer(elementId, {
                     
                     left:0
                     , right:0
                     , speed : 0.3
                     , loose : true
                     , steps : cnt
                     , centerItem : true
                     , callback: function(x, y) {
                        getStep();
                     }
                     , dragStartCallback: function (x, y) {
                        dragStart(x,y);
                     }
                     , dragStopCallback: function (x, y) {
                        dragStop(x, y);
                     }
                  });
                  isLoaded = true;
                  updateSlider();
               }, 10);
               
               
               
            }
            , getStep = function(){

               var steps = dd.getStep();
               var stepx = Number(steps[0]).toFixed(0);
               
               // remove active class
               element.find("a").removeClass("disabled eagle birdie par bogey double other " + options.activeClass);
               
               // disabled items?
               if (options.disableValue) {
                  angular.forEach(angular.element(element.find("a")), function (value, key) {
                     var a = angular.element(value);
                     var v = a.find("i").html();
                     if (!isNaN(v)) {
                        if (v > options.disableValue) {
                           a.addClass("disabled");
                        }
                     }
                  });
               }


               // Get item
               var item = angular.element(element.find("a")[stepx - 1]);

               // get html value
               var val = item.find("i").html();
               
               if (options.disableValue) {
                  if (val >= options.disableValue) {
                     options.currentValue = options.disableValue - 1;
                     updateSlider();
                     return;
                  }
               }

               // adding par class?
               var newclass = options.activeClass;
               if (options.parValue > 0 && val) {
                  if (!isNaN(val)) {
                     var strokes = Number(val);
                     var p = strokes - options.parValue;
                     if (strokes > 0) {
                        if (p < -1) {
                           newclass += " eagle";
                        }
                        if (p == -1) {
                           newclass += " birdie";
                        }
                        if (p == 0) {
                           newclass += " par";
                        }
                        if (p == 1) {
                           newclass += " bogey";
                        }
                        if (p == 2) {
                           newclass += " double";
                        }
                        if (p > 2) {
                           newclass += " other";
                        }
                     }
                  }
               }

               // add active class
               item.addClass(newclass);

               if (scope.callback){
                  scope.callback()({step: stepx, value : val, holeNumber : options.holeNumber, par : options.parValue, playerIndex : options.playerIndex});
               }
            }
            , updateSlider = function () {
               $timeout(function () {
                  
                  var step = 0;
                  var cv = (options.currentValue + "").toString();
                  if (cv != "null") {
                     step = options.currentValue - options.minValue + 1;
                     if (options.allowNull) {
                        step++;
                     }
                  }
                  
                  if (isLoaded) {
                     dd.setStep(step, 0, true);
                  }
                  
               }, 10);
            }
            , dragStart = function(x,y){
               dragSteps.step = x;
               dragSteps.isDrag = false;
            }
            , dragStop = function(x,y){
               if (x != dragSteps.step) {
                  dragSteps.isDrag = true;
               } else {
                  dragSteps.isDrag = false;
               }
            }

            scope.sc = {
               className: ""
               , f: {
                  setStep : function (b) {
                     $timeout(function () {
                        if (!dragSteps.isDrag) {
                           var step = 0;
                           var cv = (b + "").toString();
                           if (cv != "null") {
                              //step = b - options.minValue + 1;
                              step = b;
                              if (options.allowNull) {
                                 step++;
                              }
                           }

                           if (isLoaded) {
                              dd.setStep(step, 0, true);
                           }
                        }
                     }, 15);
                  }
               }
            }


            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr);
               }
            });

            
            if (attrs.id){
               elementId = attrs.id;
            }
            if (attrs.name){
               element.find("name").html(attrs.name);
            }
            if (attrs.options) {
               var optStr = attrs.options;
               //loadOptions(optStr);
            }        
         }
      }
      
   }
}(angular, app));


